import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Logo from "../../../components/Logo";
import ProgressSteps from "../../../components/ProgressSteps";
import { FormEvent, useState } from "react";
import { RequiredMark } from "../../../components/RequiredMark";

export default function ProSignupInfo2() {
  const navigate = useNavigate();
  const [pays, setPays] = useState("");
  const [ville, setVille] = useState("");
  const [nip, setNip] = useState("");
  const canProceed = pays !== "" && ville !== "" && nip !== "";

  const onSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!canProceed) return;
    navigate("/professionnel/inscription/identifiants");
  };

  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-1 flex items-center justify-center px-4 py-8">
        <div className="w-full max-w-lg">
          <Logo size={56} />
          <div className="mt-6 text-sm" style={{ color: "#00553E" }}>
            <Link to="/professionnel/inscription/informations-1" className="inline-flex items-center gap-2">
              <ArrowLeft size={16} /> Retour
            </Link>
          </div>
          <h1 className="mt-2 text-2xl font-semibold" style={{ color: "#000000" }}>
            Création de compte
          </h1>
          <div className="mt-1 text-gray-500 font-semibold">Informations personnelles</div>

          <form className="mt-6 space-y-4" onSubmit={onSubmit}>
            <div className="space-y-2">
              <label className="text-sm">
                Pays
                <RequiredMark />
              </label>
              <input placeholder="Bénin" value={pays} onChange={(event) => setPays(event.target.value)} className="w-full h-11 rounded-[10px] border-2 px-3" style={{ borderColor: "#D1E2DD" }} />
            </div>
            <div className="space-y-2">
              <label className="text-sm">
                Ville
                <RequiredMark />
              </label>
              <input placeholder="Cotonou" value={ville} onChange={(event) => setVille(event.target.value)} className="w-full h-11 rounded-[10px] border-2 px-3" style={{ borderColor: "#D1E2DD" }} />
            </div>
            <div className="space-y-2">
              <label className="text-sm">
                NIP
                <RequiredMark />
              </label>
              <input placeholder="—" value={nip} onChange={(event) => setNip(event.target.value)} className="w-full h-11 rounded-[10px] border-2 px-3" style={{ borderColor: "#D1E2DD" }} />
            </div>

            <button
              type="submit"
              className="w-full h-11 rounded-[10px] font-medium cursor-pointer"
              style={{ backgroundColor: canProceed ? "#00553E" : "#DCEFE9", color: canProceed ? "#FFFFFF" : "#7aa79a" }}
              disabled={!canProceed}
            >
              Suivant
            </button>
          </form>

          <div className="mt-8">
            <ProgressSteps step={2} total={4} />
          </div>
        </div>
      </div>
    </div>
  );
}

